import { render, staticRenderFns } from "./CoverImage.vue?vue&type=template&id=24b025e3"
import script from "./CoverImage.vue?vue&type=script&lang=ts"
export * from "./CoverImage.vue?vue&type=script&lang=ts"
import style0 from "./CoverImage.vue?vue&type=style&index=0&id=24b025e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports